/***
 * Configuration for Devices and Insects Routes
 *
 * Device Type and Device Report Type Routes
 * Insect Routes
 ***/

/* ----- Views ----- */

// Device Type - Device Report Type
import DeviceTypes from "@/pages/Devices/DeviceTypes";
import ReportTypes from "@/pages/Devices/ReportTypes";
import ReportTypeDetails from "@/pages/Devices/ReportTypeDetails";

// Insect
import Insects from "@/pages/Configuration/Insects";
import InsectAdd from "@/pages/Configuration/Insects/InsectAdd";
import InsectEdit from "@/pages/Configuration/Insects/InsectEdit";

/* ----- ----- ----- ----- ----- ----- ----- */

// Utils
import { generateParentsList } from "@/router/utils";

// Parents List
const parentsList = {
    reportDeviceTypesIndex: { label: 'Liste des modèles de fiche de suivi des dispositifs', name: 'Report Types' },
    insectsIndex: { label: 'Liste des insectes', name: 'Insects' }
}

const deviceRoutes = [
    {
        path: 'device_types',
        name: 'Device Types',
        component: DeviceTypes,
        meta: {
            route: {
                label: 'Liste des types de dispositifs'
            }
        },
    },
    {
        path: 'report_types',
        name: 'Report Types',
        component: ReportTypes,
        meta: {
            route: {
                label: 'Liste des modèles de fiche de suivi des dispositifs'
            }
        },
    },
    {
        path: 'report_types/:id',
        name: 'Report Type Details',
        component: ReportTypeDetails,
        meta: {
            route: {
                label: 'Fiche de suivi des dispositifs',
                params: { name: 'id', model: 'DeviceReportType', column: 'name' },
            },
            parents: generateParentsList(parentsList, ['reportDeviceTypesIndex']),
        },
    },
]

const insectRoutes = [
    {
        path: 'insects',
        name: 'Insects',
        component: Insects,
        meta: {
            route: {
                label: 'Liste des insectes'
            }
        },
    },
    {
        path: 'insects/create',
        name: 'Add Insect',
        component: InsectAdd,
        meta: {
            route: {
                label: 'Ajout d\'un insecte'
            },
            parents: generateParentsList(parentsList, ['insectsIndex']),
        },
    },
    {
        path: 'insects/:id/edit',
        name: 'Edit Insect',
        component: InsectEdit,
        meta: {
            route: {
                label: 'Modification d\'un insecte',
                params: { name: 'id', model: 'Insect', column: 'name' },
            },
            parents: generateParentsList(parentsList, ['insectsIndex']),
        },
    },
]

const routes = [...deviceRoutes, ...insectRoutes]
export default routes